module.exports = __webpack_public_path__ + "static/media/paypal-logo-4.a371d4bd.png";